// extracted by mini-css-extract-plugin
export default {"modalContainer":"XlsModal_modalContainer__1zhfY","content":"XlsModal_content__3-NNp"};